import { createFileRoute } from "@tanstack/react-router"
import { Scoped } from "@/components/forms/students/resubmit/UseStudentResubmitStepper"
import StudentFormStepper from "@/components/forms/students/resubmit/StudentFormStepper"
import ScreenWrapper from "@/components/ScreenWrapper"
import { useStudentResubmitStore } from "@/stores/useStudentResubmitStore"
import { useMemo } from "react"

export const Route = createFileRoute(
  "/beheer/aanmeldingen/$studentRegistrationId/opnieuw-indienen",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { studentRegistrationId } = Route.useParams()
  const projectStepData = useStudentResubmitStore((s) => s.projectStepData)

  const initialStep: "contract" | "personal" = useMemo(() => {
    if (projectStepData) return "personal"

    return "contract"
  }, [projectStepData])

  return (
    <ScreenWrapper showManagementMenu>
      <Scoped initialStep={initialStep}>
        <StudentFormStepper
          studentRegistrationId={Number(studentRegistrationId)}
        />
      </Scoped>
    </ScreenWrapper>
  )
}
